module.exports = __webpack_public_path__ + "static/img/23.347e5d6f.png";